import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["url"];

  connect() {
    this.element.addEventListener(
      "show.bs.modal",
      this.handleModalShow.bind(this),
    );
  }

  disconnect() {
    this.element.removeEventListener(
      "show.bs.modal",
      this.handleModalShow.bind(this),
    );
  }

  async handleModalShow(event) {
    const url = event.relatedTarget?.dataset?.turboModalUrlParam;
    if (!url) {
      console.error("No URL provided");
      event.preventDefault();
      return;
    }
    const response = await get(url, { responseKind: "turbo-stream" });
    if (!response.ok) {
      console.error("Something went wrong.");
      return;
    }
  }
}
